import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

// Import shared components and modules
import { SharedModule } from '@client/ng2/shared/shared.module';
import { ChartsModule } from '@client/app/modules/charts/charts.module';
import {
    LabelModule,
    LayoutModule,
    MonEventTriggerModule,
    MonTableSortModule,
    TableModule,
} from '@monsido/angular-shared-components';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ExportModule } from '@client/app/modules/export/export.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { TablePolicyTypeComponent } from '@monsido/modules/table-policy-type/table-policy-type.component';
import { DoughnutComponent } from '@client/app/modules/charts/components/doughnut.component';
import { QuickHelpComplianceStatusModule } from '@client/app/components/quick-help-compliance-status/quick-help-compliance-status.module';
import { ExtensionModule } from '@client/app/modules/extension/extension.module';
import { ActiveFeaturePipe } from '@monsido/core/pipes/active-feature/active-feature.pipe';
import { ImportantHighlightsComponent } from '@client/app/pages/qa/summary/important-highlights/important-highlights.component';
import { LastScanComponent } from '@client/app/pages/qa/summary/last-scan/last-scan.component';
import { QaSummaryReadabilityComponent } from '@client/app/pages/qa/summary/readability/qa-summary-readability.component';
import { ViolationModulesComponent } from '@client/app/pages/qa/summary/violation-modules/violation-modules.component';
import { LinkContentComponent } from '@client/app/pages/qa/broken-links/links/link-content/link-content.component';
import { BrokenPagesIndexComponent } from '@client/app/pages/qa/broken-links/pages/broken-pages-index.component';
import { QualityPagesComponent } from '@client/app/pages/qa/pages/quality-pages.component';
import { ReadabilityPagesWithScoreComponent } from '@client/app/pages/qa/readability/summary/pages-with-score/pages-with-score.component';
import { ReadabilitySummaryResultsComponent } from '@client/app/pages/qa/readability/summary/results/results.component';
import { ReadabilitySummaryScoreComponent } from '@client/app/pages/qa/readability/summary/score/readability-summary-score.component';
import { BrokenImagesIndexComponent } from '@client/app/pages/qa/broken-links/images/broken-images-index.component';
import { ReadabilitySummaryComponent } from '@client/app/pages/qa/readability/summary/summary.component';
import { HorizontalBarComponent } from '@client/app/modules/charts/components/horizontal-bar.component';
import { BrokenLinksIndexComponent } from '@client/app/pages/qa/broken-links/links/broken-links-index.component';
import { SpellingDashboardMisspellingsComponent } from '@client/app/pages/qa/spellcheck/dashboard/spelling-dashboard-misspellings.component';
import { SpellingDashboardComponent } from '@client/app/pages/qa/spellcheck/dashboard/spelling-dashboard.component';
import { SpellingDictionaryIndexComponent } from '@client/app/pages/qa/spellcheck/dictionary/spelling-dictionary-index.component';
import { SpellingErrorsIndexComponent } from '@client/app/pages/qa/spellcheck/errors/spelling-errors-index.component';
import { IgnoredMisspellingsComponent } from '@client/app/pages/qa/spellcheck/ignoredMisspellings/ignored-misspellings.component';
import { SpellingPagesDialogComponent } from '@client/app/pages/qa/spellcheck/pages/spelling-pages-dialog.component';
import { SpellingPagesWithErrorComponent } from '@client/app/pages/qa/spellcheck/pages-with-error/spelling-pages-with-error.component';
import { SpellingPlayComponent } from '@client/app/pages/qa/spellcheck/play/spelling-play.component';
import { ClassificationComponent } from '@client/app/components/classification/classification.component';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { QualitySummaryComponent } from '@client/app/pages/qa/summary/quality-summary.component';
import { BrokenSitemapIndexComponent } from '@client/app/pages/qa/broken-links/sitemap/broken-sitemap-index.component';
import { ReadabilityCheckerComponent } from '@client/app/pages/qa/readability/checker/checker.component';
import { LanguageMatchSummaryComponent } from '@client/app/pages/qa/language-match/summary/language-match-summary.component';
import { LanguageMatchPagesComponent } from '@client/app/pages/qa/language-match/pages/language-match-pages.component';
import { LanguageDistributionProgressBarComponent } from '@client/app/pages/qa/language-match/summary/components/language-distribution-progress-bar/language-distribution-progress-bar.component';
import { LanguagesModule } from '@client/app/modules/languages-ng2/languages.module';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        ImportantHighlightsComponent,
        LastScanComponent,
        QaSummaryReadabilityComponent,
        ViolationModulesComponent,
        LinkContentComponent,
        BrokenPagesIndexComponent,
        QualityPagesComponent,
        ReadabilityPagesWithScoreComponent,
        ReadabilitySummaryResultsComponent,
        ReadabilitySummaryScoreComponent,
        BrokenImagesIndexComponent,
        ReadabilitySummaryComponent,
        BrokenLinksIndexComponent,
        SpellingDashboardMisspellingsComponent,
        SpellingDashboardComponent,
        SpellingDictionaryIndexComponent,
        SpellingErrorsIndexComponent,
        IgnoredMisspellingsComponent,
        SpellingPagesDialogComponent,
        SpellingPagesWithErrorComponent,
        SpellingPlayComponent,
        QualitySummaryComponent,
        BrokenSitemapIndexComponent,
        ReadabilityCheckerComponent,
        LanguageMatchSummaryComponent,
        LanguageMatchPagesComponent,
        LanguageDistributionProgressBarComponent,
    ],
    imports: [
        FormsModule,
        ExportModule,
        TranslateModule,
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        UIRouterModule,
        SharedModule,
        ChartsModule,
        TableModule,
        NgbModule,
        LayoutModule,
        ModalsDirectivesModule,
        TablePolicyTypeComponent,
        MonEventTriggerModule,
        DoughnutComponent,
        QuickHelpComplianceStatusModule,
        MonTableSortModule,
        ExtensionModule,
        ActiveFeaturePipe,
        LabelModule,
        HorizontalBarComponent,
        ClassificationComponent,
        LineComponent,
        LanguagesModule,
    ],
    providers: [],
})
export class UpgradeQaModule {}
